"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var moment = require("moment");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Types = require("types");
var sok_ui_1 = require("@caddigital/sok-ui");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var Thumbnails_1 = require("components/Thumbnails");
require("./index.scss");
var options_1 = require("./options");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var DatePicker_1 = require("components/DatePicker");
var trmeterRemarkImages_1 = require("actions/trmeterRemarkImages");
var mapStateToProps = function (state) {
    return {
        currentTrmvrMeter: state.sokosite.current.trmvrMeter,
        currentEntry: state.trmvrmeterentries.current.currentEntry,
        currentRemark: state.trmvrmeterentries.remark.currentRemark,
        currentRemarkImages: state.trmvrmeterentries.remark.currentRemarkImages,
        currentRemarkConfirmationImages: state.trmvrmeterentries.remark.currentRemarkConfirmationImages,
        validation: state.trmvrmeterentries.remark.validation
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    toggleUploadModal: function () { return dispatch(trmeterRemarkImages_1.default.toggleModalStatus()); },
    toggleUploadReplace: function (replace) {
        return dispatch(trmeterRemarkImages_1.default.toggleReplace(replace));
    },
    toggleUnzip: function (unzip) { return dispatch(trmeterRemarkImages_1.default.toggleUnzip(unzip)); }
}); };
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('target', 'setTarget', ''), (0, recompose_1.withState)('remark', 'setRemark', ''), (0, recompose_1.withState)('company', 'setCompany', ''), (0, recompose_1.withState)('dueDate', 'setDueDate', moment()), (0, recompose_1.withState)('info', 'setInfo', ''), (0, recompose_1.withState)('comment', 'setComment', ''), (0, recompose_1.withState)('remarks', 'setRemarks', []), react_router_dom_1.withRouter, recompose_1.pure);
function RemarkImages(props) {
    var AddImagesButton = function () { return (React.createElement(sok_ui_1.Button, { color: "blue", iconRight: React.createElement(sok_ui_1.Icon, { className: "fal fa-camera" }), disabled: props.disabled, onClick: props.onClick }, (0, translation_1.getLocalization)('trmeterentryview/modal/addImages'))); };
    return (React.createElement("div", { className: "remark-modal-field info-field" },
        React.createElement("label", { htmlFor: 'info-input' }, (0, translation_1.getLocalization)('trmeterentryview/modal/images')),
        props.remarkNotSaved ? (React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, (0, translation_1.getLocalization)("trmeterentryview/modal/saveToAddImages")) },
            React.createElement(AddImagesButton, null))) : (React.createElement(AddImagesButton, null)),
        React.createElement(Thumbnails_1.Thumbnails, { items: props.files, itemsPerRow: {
                DESKTOP: 3
            } })));
}
function getValidationError(validation, field) {
    if (validation.status === 'ERROR') {
        var errors = validation.errors[field];
        if (errors !== undefined && errors.length > 0) {
            return React.createElement("p", { className: 'form-error' }, errors[0]);
        }
    }
    return undefined;
}
exports.default = enhance(function (props) {
    var _a = React.useState(false), modalOpen = _a[0], setModalOpen = _a[1];
    var _b = React.useState(false), signed = _b[0], setSigned = _b[1];
    var _c = React.useState(false), confirmOpen = _c[0], setConfirmOpen = _c[1];
    var selectedTargetOptions = props.isTRMeter
        ? options_1.targetOptions
        : options_1.targetOptionsMvr;
    var selectedFilterRemarkOptions = props.isTRMeter
        ? options_1.filterRemarkOptions
        : options_1.filterRemarkOptionsMvr;
    var TRMVRMeterPerm = props.currentTrmvrMeter && props.currentTrmvrMeter.perm
        ? props.currentTrmvrMeter.perm
        : 0x00;
    var remarkIsConfirmed = function () {
        return props.currentRemark && props.currentRemark.confirmed_at !== undefined;
    };
    var disableFieldsHelper = function () {
        if (acl.hasGrant(props.perm, acl.SUPER_ADMIN_GRANT) ||
            acl.hasGrant(TRMVRMeterPerm, acl.TRMVRMETER_EMPLOYER_GRANT)) {
            if (signed) {
                return true;
            }
            else {
                return false;
            }
        }
        return true;
    };
    React.useEffect(function () {
        props.toggleUploadReplace(false);
        props.toggleUnzip(true);
        props.setTarget("".concat(selectedTargetOptions[0].id));
        props.setRemarks(selectedFilterRemarkOptions(selectedTargetOptions[0].id));
        props.setDueDate(moment());
    }, []);
    React.useEffect(function () {
        if (!props.currentRemark && props.remarks.length > 0) {
            props.setRemark("".concat(props.remarks[0].id));
        }
        if (props.currentRemark) {
            props.setRemark(modalOpen ? "".concat(props.remarks[0].id) : props.currentRemark.remark);
            setModalOpen(true);
        }
    }, [props.target, props.remarks]);
    React.useEffect(function () {
        if (props.currentRemark) {
            props.setTarget(props.currentRemark.target);
            props.setRemarks(selectedFilterRemarkOptions(props.currentRemark.target));
            props.setRemark(props.currentRemark.remark);
            props.setCompany(props.currentRemark.responsible_company);
            props.setDueDate(moment(props.currentRemark.must_be_fixed_at));
            props.setInfo(props.currentRemark.additional_info
                ? props.currentRemark.additional_info
                : '');
            props.setComment(props.currentRemark.confirmation_comment
                ? props.currentRemark.confirmation_comment
                : '');
            setModalOpen(false);
        }
    }, [props.currentRemark]);
    var formFieldsEdited = function () {
        var propRemark = {
            target: props.target,
            remark: props.remark,
            responsible_company: props.company,
            must_be_fixed_at: moment(props.dueDate).format('L'),
            additional_info: props.info,
            confirmation_comment: props.comment
        };
        if (props.currentRemark) {
            var currentRemark = {
                target: props.currentRemark.target,
                remark: props.currentRemark.remark,
                responsible_company: props.currentRemark.responsible_company,
                must_be_fixed_at: moment(props.currentRemark.must_be_fixed_at).format('L'),
                additional_info: props.currentRemark.additional_info
                    ? props.currentRemark.additional_info
                    : '',
                confirmation_comment: props.currentRemark.confirmation_comment
                    ? props.currentRemark.confirmation_comment
                    : ''
            };
            if (JSON.stringify(propRemark) === JSON.stringify(currentRemark)) {
                return false;
            }
        }
        else {
            return false;
        }
        return true;
    };
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.show, className: 'remark-modal' },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                props.closeModal();
            } }, (0, translation_1.getLocalization)('trmeterentryview/modal/header')),
        React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
                var remark = {
                    target: props.target || undefined,
                    remark: props.remark,
                    responsible_company: props.company,
                    must_be_fixed_at: moment(props.dueDate).toISOString(),
                    additional_info: props.info,
                    confirmation_comment: props.comment
                };
                props.saveFunction(remark, props.currentRemark ? props.currentRemark.uuid : undefined);
                // TODO : Toast which tells that the remark is saved
            } },
            React.createElement(sok_ui_1.Container, null,
                React.createElement("div", { className: 'modal-content' },
                    React.createElement("div", { className: "remark-box-wrapper" },
                        React.createElement(sok_ui_1.AccordionPanel, { title: (0, translation_1.getLocalization)('trmeterentryview/modal/accordion/details') },
                            React.createElement("div", { className: "remark-box-content" },
                                React.createElement(sok_ui_1.Dropdown2, { className: "target-dropdown", clickable: (props.currentRemark &&
                                        props.currentRemark.confirmed_at) ||
                                        disableFieldsHelper()
                                        ? false
                                        : true },
                                    React.createElement("div", { className: "" },
                                        React.createElement("label", { htmlFor: 'target-input' }, (0, translation_1.getLocalization)('trmeterentryview/modal/target')),
                                        props.currentRemark &&
                                            props.currentRemark.confirmed_at ? (React.createElement("p", { id: 'target-input' }, "".concat(props.target, " ").concat((0, options_1.findNameWithId)(props.target ? props.target : '', selectedTargetOptions)))) : (React.createElement(sok_ui_1.TextInput, { autoComplete: "off", id: 'target-input', value: "".concat(props.target, " ").concat((0, options_1.findNameWithId)(props.target ? props.target : '', selectedTargetOptions)), readOnly: true, required: true, disabled: disableFieldsHelper(), className: 'white' }))),
                                    React.createElement(sok_ui_1.Dropdown2Menu, { className: "target-dropdown-menu" }, selectedTargetOptions.map(function (option) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: option.id, onClick: function () {
                                            props.setTarget("".concat(option.id));
                                            props.setRemarks(selectedFilterRemarkOptions(option.id));
                                        } },
                                        React.createElement("div", null,
                                            React.createElement("span", null, "".concat(option.id, " ").concat((0, translation_1.getLocalization)(option.name)))))); }))),
                                React.createElement(sok_ui_1.Dropdown2, { className: "remark-dropdown", direction: "down", clickable: (props.currentRemark &&
                                        props.currentRemark.confirmed_at) ||
                                        disableFieldsHelper()
                                        ? false
                                        : true },
                                    React.createElement("div", { className: "" },
                                        React.createElement("label", { htmlFor: 'remark-input' }, (0, translation_1.getLocalization)('trmeterentryview/modal/remark')),
                                        props.currentRemark &&
                                            props.currentRemark.confirmed_at ? (React.createElement("p", { id: 'remark-input' }, "".concat(props.remark, " ").concat((0, options_1.findNameWithId)(props.remark ? props.remark : '', props.remarks)))) : (React.createElement(sok_ui_1.TextInput, { autoComplete: "off", id: 'remark-input', value: "".concat(props.remark, " ").concat((0, options_1.findNameWithId)(props.remark ? props.remark : '', props.remarks)), readOnly: true, required: true, disabled: disableFieldsHelper(), className: 'white' }))),
                                    React.createElement(sok_ui_1.Dropdown2Menu, { className: "remark-dropdown-menu" }, props.remarks.map(function (option) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: option.id, onClick: function () { return props.setRemark("".concat(option.id)); } },
                                        React.createElement("div", null,
                                            React.createElement("span", null, "".concat(option.id, " ").concat((0, translation_1.getLocalization)(option.name)))))); }))),
                                React.createElement("div", { className: "remark-modal-field" },
                                    React.createElement("label", { htmlFor: 'company-input' }, (0, translation_1.getLocalization)('trmeterentryview/modal/company')),
                                    props.currentRemark && props.currentRemark.confirmed_at ? (React.createElement("p", { id: 'company-input' }, props.company)) : (React.createElement(sok_ui_1.TextInput, { id: 'company-input', value: props.company, disabled: disableFieldsHelper(), className: 'white', onChange: function (e) {
                                            return props.setCompany(e.target.value);
                                        } })),
                                    getValidationError(props.validation, 'responsible_company')),
                                React.createElement("div", { className: "remark-modal-field" },
                                    React.createElement("label", { htmlFor: 'duedate-input' }, (0, translation_1.getLocalization)('trmeterentryview/modal/duedate')),
                                    props.currentRemark && props.currentRemark.confirmed_at ? (React.createElement("p", { id: 'duedate-input' }, props.dueDate.format('L'))) : (React.createElement(DatePicker_1.DatePicker, { id: 'duedate-input', disabled: disableFieldsHelper(), selected: props.dueDate, onChange: function (e) {
                                            props.setDueDate(e);
                                        }, dateFormat: "L", minDate: moment() })),
                                    getValidationError(props.validation, 'must_be_fixed_at')),
                                React.createElement("div", { className: "remark-modal-field info-field" },
                                    React.createElement("label", { htmlFor: 'info-input' }, (0, translation_1.getLocalization)('trmeterentryview/modal/info')),
                                    props.currentRemark && props.currentRemark.confirmed_at ? (React.createElement("p", { id: 'info-input' }, props.info)) : (React.createElement(sok_ui_1.TextInput, { id: 'info-input', value: props.info, type: "textarea", rows: 3, disabled: disableFieldsHelper(), className: 'white', onChange: function (e) {
                                            return props.setInfo(e.target.value);
                                        } }))),
                                React.createElement(RemarkImages, { disabled: !props.currentRemark ||
                                        remarkIsConfirmed() ||
                                        disableFieldsHelper(), files: props.currentRemarkImages.files, onClick: function () {
                                        if (props.currentRemark &&
                                            props.currentRemark.image_folder) {
                                            props.setUploadFolder(props.currentRemark.image_folder);
                                            props.toggleUploadModal();
                                        }
                                    }, remarkNotSaved: !props.currentRemark })))),
                    props.currentRemark && (React.createElement("div", { className: "confirmation-box-wrapper" },
                        React.createElement(sok_ui_1.AccordionPanel, { title: (0, translation_1.getLocalization)('trmeterentryview/modal/accordion/confirmation') },
                            React.createElement("div", { className: "confirmation-box-content" },
                                props.currentRemark && props.currentRemark.confirmed_at ? (React.createElement("p", null, "".concat((0, translation_1.getLocalization)('trmeterentryview/modal/signedby'), " ").concat(typeof props.currentRemark.confirmed_by === 'number'
                                    ? props.currentRemark.confirmed_by
                                    : props.currentRemark.confirmed_by.firstName, " ").concat(typeof props.currentRemark.confirmed_by === 'number'
                                    ? props.currentRemark.confirmed_by
                                    : props.currentRemark.confirmed_by.lastName, " ").concat(moment(props.currentRemark.confirmed_at).format('L HH:mm')))) : (React.createElement("p", null, (0, translation_1.getLocalization)('trmeterentryview/modal/instruction'))),
                                React.createElement("div", { className: "remark-modal-field" },
                                    React.createElement("label", { htmlFor: 'comment-input' }, (0, translation_1.getLocalization)('trmeterentryview/modal/comment')),
                                    props.currentRemark &&
                                        props.currentRemark.confirmed_at ? (React.createElement("p", { id: 'comment-input' }, props.comment)) : (React.createElement(sok_ui_1.TextInput, { id: 'comment-input', value: props.comment, type: "textarea", rows: 3, disabled: disableFieldsHelper(), className: 'white', onChange: function (e) {
                                            return props.setComment(e.target.value);
                                        } }))),
                                React.createElement(RemarkImages, { disabled: !props.currentRemark ||
                                        remarkIsConfirmed() ||
                                        disableFieldsHelper(), files: props.currentRemarkConfirmationImages.files, onClick: function () {
                                        if (props.currentRemark &&
                                            props.currentRemark.confirmation_image_folder) {
                                            props.setUploadFolder(props.currentRemark.confirmation_image_folder);
                                            props.toggleUploadModal();
                                        }
                                    }, remarkNotSaved: !props.currentRemark }),
                                React.createElement(sok_ui_1.Button, { className: 'sign-button', type: 'submit', color: 'green', text: (0, translation_1.getLocalization)('trmeterentryview/modal/sign'), iconRight: React.createElement(sok_ui_1.Icon, { className: "fa-solid fa-check" }), disabled: props.currentRemark &&
                                        !props.currentRemark.confirmed_at &&
                                        !disableFieldsHelper()
                                        ? false
                                        : true, onClick: function (e) {
                                        e.preventDefault();
                                        if (props.currentRemark) {
                                            var updatedRemark = {
                                                target: props.target,
                                                remark: props.remark,
                                                responsible_company: props.company,
                                                must_be_fixed_at: moment(props.dueDate).toISOString(),
                                                additional_info: props.info,
                                                confirmation_comment: props.comment,
                                                confirmed_by: 1
                                            };
                                            props.saveFunction(updatedRemark, props.currentRemark
                                                ? props.currentRemark.uuid
                                                : undefined);
                                            setSigned(true);
                                        }
                                        else {
                                            alert('Error while saving');
                                        }
                                    } }))))))),
            React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: confirmOpen, close: function () { return setConfirmOpen(false); }, header: (0, translation_1.getLocalization)('trmeterentryview/confirmationModal/header'), body: React.createElement(React.Fragment, null,
                    React.createElement(ConfirmDialog_1.Exclamation, null),
                    React.createElement("div", null,
                        React.createElement("div", { className: 'title please-confirm-text' },
                            React.createElement("h2", { className: "title" }, (0, translation_1.getLocalization)('trmeterentryview/confirmationModal/title'))),
                        React.createElement("div", { className: 'text' }, (0, translation_1.getLocalization)('trmeterentryview/confirmationModal/description')))), footer: React.createElement(React.Fragment, null,
                    React.createElement(sok_ui_1.Button, { color: 'red', text: (0, translation_1.getLocalization)('trmeterentryview/confirmationModal/confirm'), onClick: function () {
                            props.closeModal();
                            setConfirmOpen(false);
                        } }),
                    React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('trmeterentryview/confirmationModal/cancel'), onClick: function () { return setConfirmOpen(false); } })) }),
            React.createElement(sok_ui_1.Footer, null,
                ((props.currentRemark && !props.currentRemark.confirmed_at) ||
                    !props.currentRemark) && (React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('trmeterentryview/modal/save'), type: "submit", color: 'base-green' })),
                React.createElement(sok_ui_1.Button, { type: "button", text: (0, translation_1.getLocalization)('trmeterentryview/modal/close'), color: 'dark-gray', onClick: function () {
                        if (formFieldsEdited()) {
                            setConfirmOpen(true);
                        }
                        else {
                            props.closeModal();
                        }
                    } })))));
});
